<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WLpLM4/images/9781488018817_fmt.jpeg?1697035686253" alt="This image is the cover for the book Big Sky Showdown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Big Sky Showdown
      </h1>
      <p class="bookDescription body article font2">
        <p>DANGER ON THE MOUNTAIN <br/><br/>When Heather Jacobs climbs a Montana mountain to pay respects to her late father, the last thing she expects is to be running for her life. But she's living a real-life cat-and-mouse chase, trying to escape a punishing foe from her guide Zane Scofield's past. How can a California city girl help outwit a ruthless criminal dead set on scouring the wilderness to kill them? Though Zane knows their pursuer and his nefarious motives far too well, he's not sure why the man is after him now. Only his witsand an unlikely partner in the determined woman fighting beside himcan save them. But Zane's also battling a past that's threatening to swallow him wholeand take Heather along with him.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Dunn
      </h2>
      
      <p class="authorDescription body article">Sharon Dunn grew up in the country where there was ample opportunity for her imagination to flourish. She started writing when she was pregnant with her oldest son. Three kids and a lot of diaper changes later, she has published both award winning humorous mysteries and romantic suspense. Her hobbies include reading in small increments, trying to find things around&#160;the house, being the mom taxi, and making pets out of the dust bunnies under her furniture.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c8a55d6